
import { ref } from 'vue'
import moment from 'moment'
export default {
  setup() {
    const Year = ref(moment().format('YYYY'))
    return { Year }
  }
}
